import React, { useEffect, useState } from "react";
import { Sidebar, Menu, MenuItem, SubMenu } from "react-pro-sidebar";
import { Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { loadCreditsData, logoutFunction } from "../redux/action";
import * as HeaderAuthentication from "../HeaderAuthentication";
import { ClearBtn, SearchBtn } from "../Buttons/Buttons";
import companyLogo from "../../assets/images/signin/logo-dark.png";
import demoLogo from "../../assets/images/signin/logo-dark-copy.png";
import logOutImg from "../../assets/images/signin/log_out.png";
import "../../assets/css/layout.scss";
import { useLocation } from "react-router-dom";
import { loadUploadedContacts } from "../redux/action"; // or the correct path




const AppSidebar = ({ collapsed, setCollapsed }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  
  const activeFilter = new URLSearchParams(location.search).get("filter");
  const navigate = useNavigate();
  
  const [selectedFilterValue, setSelectedFilterValue] = useState("");
  // For the table data
const [rows, setRows] = useState([]);
const [loading, setLoading] = useState(false);

// Your user ID from sign-in details



  const signInDetails = JSON.parse(sessionStorage.getItem("SignInDetails"));
  const signInID = signInDetails?.[0]?.id;
  const expiryStatus = signInDetails?.[0]?.expiryStatus || "";
  const { getCredits } = useSelector((state) => state.data);
  const [modalShow, setModalShow] = useState(false);
  const [menuToggle, setMenuToggle] = useState(false);
  const user_role = signInDetails?.[0]?.role?.toLowerCase().trim();
  // --- MY CONTACTS MENU STATE ---
const [contactsMenuToggle, setContactsMenuToggle] = useState(false);

// const isContactsMenuOpen =
//   location.pathname === "/contact-filter" ||
//   location.pathname.startsWith("/contact-filter?") ||
//   location.pathname === "/viewed-contacts" ||
//   location.pathname === "/saved-searches";
const isContactsActive =
  location.pathname === ("/contact-filter") ||
  location.pathname === "/viewed-contacts" ||
  location.pathname === "/saved-searches";

// const contactsMenuOpen = isContactsMenuOpen || contactsMenuToggle;
const [contactsMenuOpen, setContactsMenuOpen] = useState(false); 
const [contactModalShow, setContactModalShow] = useState(false);
const [contactType, setContactType] = useState(""); // Track which contact type was clicked
const getFieldKeyByType = (type) => {
  switch (type) {
    case "contactType":
      return "job_level";
    case "location":
      return "country";
    case "company":
      return "company";
    case "industry":
      return "industry";
    case "technology":
      return "technology";
    case "continent":
      return "continent";
    default:
      return "";
  }
};

const filterIcons = {
  contactType: <i className="bx bx-briefcase" style={{ fontSize: "20px" }} />,
  location: <i className="bx bx-globe" style={{ fontSize: "20px" }} />,
  company: <i className="bx bx-buildings" style={{ fontSize: "20px" }} />,
  industry: <i className="fa fa-industry" style={{ fontSize: "20px" }} />,
  technology: <i className="bx bx-chip" style={{ fontSize: "20px" }} />,
  continent: <i className="bx bx-search-alt" style={{ fontSize: "20px" }} />,
};

const [accordionOpen, setAccordionOpen] = useState({});
const [contactFilters, setContactFilters] = useState({});
const [contactData, setContactData] = useState([]);
const [loadingContacts, setLoadingContacts] = useState(false);
const [filteredContacts, setFilteredContacts] = useState([]);
const applyContactFilters = () => {
  let filtered = [...contactData];

  Object.entries(contactFilters).forEach(([type, values]) => {
    if (!values.length) return;

    const fieldKey = getFieldKeyByType(type);

    filtered = filtered.filter((item) =>
      values.includes(item[fieldKey])
    );
  });

  setFilteredContacts(filtered);

  // build URL params
  const params = new URLSearchParams();
  Object.entries(contactFilters).forEach(([key, values]) => {
    if (values.length) {
      params.append(key, values.join(","));
    }
  });

  navigate(`/contact-filter?${params.toString()}`);
};

const isRequestMenuOpen =
  location.pathname === "/project" || location.pathname === "/sample";
  const menuOpen = user_role === "b2buser" || isRequestMenuOpen || menuToggle;

  // const menuOpen = isRequestMenuOpen || menuToggle;
  
  useEffect(() => {
    if (signInDetails?.[0]) {
      dispatch(loadCreditsData(signInDetails[0].sbn_id, signInDetails[0].id));
    }
  }, [dispatch]);

  useEffect(() => {
  if (!signInID) return;

  setLoadingContacts(true);

  dispatch(
    loadUploadedContacts(signInID, (data) => {
      setContactData(data || []);
      setLoadingContacts(false);
    }, setLoadingContacts)
  );
}, [dispatch, signInID]);
const getUniqueValues = (type) => {
  const fieldKey = getFieldKeyByType(type);

  return [
    ...new Set(
      contactData
        .map((item) => item[fieldKey])
        .filter((val) => val && val.trim() !== "")
    ),
  ];
};

useEffect(() => {
  if (!contactData.length) return;

  let filtered = [...contactData];

  Object.entries(contactFilters).forEach(([type, values]) => {
    if (!values.length) return;

    const fieldKey = getFieldKeyByType(type);
    filtered = filtered.filter((item) =>
      values.includes(item[fieldKey])
    );
  });

  setFilteredContacts(filtered);

  const params = new URLSearchParams();
  Object.entries(contactFilters).forEach(([key, values]) => {
    if (values.length) {
      params.set(key, values.join(","));
    }
  });

  // ✅ ONLY navigate if already on contact page
  if (
    location.pathname === "/contact-filter" ||
    location.pathname.startsWith("/contact-filter")
  ) {
    navigate(`/contact-filter?${params.toString()}`, { replace: true });
  }
}, [contactFilters, contactData, location.pathname]);

const toggleFilterValue = (type, value) => {
  setContactFilters((prev) => {
    const existing = prev[type] || [];

    return {
      ...prev,
      [type]: existing.includes(value)
        ? existing.filter((v) => v !== value)
        : [...existing, value],
    };
  });
};

  const logOutPage = () => {
    const logout_body = {
      user_id: parseInt(signInDetails[0]?.id),
      session_id: signInDetails[0]?.session_id,
    };
    const logout_post = {
      method: "POST",
      mode: "cors",
      headers: HeaderAuthentication.postAuthOfLeadMerge,
      body: JSON.stringify(logout_body),
    };
    dispatch(logoutFunction(logout_post));
  };

  const isActive = (paths, opts = {}) => {
    const list = Array.isArray(paths) ? paths : [paths];

    const current = location.pathname || '/';
    
    const exactMatch = list.some(p => p === current);
    if (exactMatch) {
      return {
        background: "#e9f2ff",
        color: "#0d6efd",
        borderLeft: "4px solid #0d6efd",
        borderRadius: "0px",
        fontWeight: "500",
      };
    }

    if (opts.prefix) {
      const prefixMatch = list.some(p => {
        if (!p) return false;
        if (p === "/") return current === "/";
        return current.startsWith(p.endsWith("/") ? p : p + "/");
      });
      if (prefixMatch) {
        return {
          background: "#e9f2ff",
          color: "#0d6efd",
          borderLeft: "4px solid #0d6efd",
          borderRadius: "0px",
          fontWeight: "500",
        };
      }
    }

    return {};
  };

  return (
    <>
      <Sidebar collapsed={collapsed} className="app-sidebar"
        style={{height: "100vh", position: "fixed", left: 0, top: 0, background: "#ffffff", borderRight: "1px solid #e5e5e5", transition: "all 0.3s ease", zIndex: 1050,
        }}
      >
        <div
          className="sidebar-header"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "20px 10px",
            borderBottom: "1px solid #f0f0f0",
          }}
        >
          
        <Link to="/dashboard" style={{ textDecoration: "none" }}>
          <img
            src={collapsed ? companyLogo : demoLogo}
            alt="Company Logo"
            style={{
              width: collapsed ? "45px" : "80%",
              cursor: "pointer", 
              transition: "all 0.3s ease",
            }}
          />
        </Link>
        </div>

        <Menu iconShape="circle">
          {user_role !== "b2buser" && (
          <MenuItem title="Home" icon={<i className="bx bx-home" style={{ fontSize: "20px" }}></i>}
            href="/dashboard" style={{fontSize: "14px", padding: "10px 20px", display: "flex", alignItems: "center", 
              ...isActive(["/", "/dashboard"])
            }}
          >
            Home
          </MenuItem>
          )}

          {["admin", "super_admin"].includes(user_role) && (
            <>
              <SubMenu title="Search" label="Search" icon={<i className="bx bx-search" style={{ fontSize: "20px" }}></i>}
                style={{ fontSize: "14px", padding: "10px 20px" }}
              >
                <MenuItem href="/contact-filter" style={isActive("/contact-filter")}>
                  Contacts
                </MenuItem>
                <MenuItem href="/saved-searches" style={isActive("/saved-searches")}>
                  Saved Searches
                </MenuItem>
                <MenuItem href="/viewed-contacts" style={isActive("/viewed-contacts")}>
                  Viewed Contacts
                </MenuItem>
              </SubMenu>

              <SubMenu title="Report" label="Report" icon={<i className="bx bx-bar-chart-alt" style={{ fontSize: "20px" }}></i>}
                style={{ fontSize: "14px", padding: "10px 20px" }}
              >
                <MenuItem href="/upload-reports" style={isActive("/upload-reports")}>
                  Upload Report
                </MenuItem>
                <MenuItem href="/data-count" style={isActive("/data-count")}>
                  Data Count
                </MenuItem>
              </SubMenu>

              <MenuItem title="My List" icon={<i className="bx bx-list-ul" style={{ fontSize: "20px" }}></i>}
                href="/my-list" style={{ fontSize: "14px", padding: "10px 20px", ...isActive("/my-list") }}>
                My List
              </MenuItem>
            </>
          )}
          {["client", "b2buser", "bde"].includes(user_role) && (
            <SubMenu open={menuOpen} style={{ fontSize: "14px", padding: "0px" }}
              label={<div className={location.pathname === "/raiserequest" ? "request-active" : ""} style={{ width: "100%", padding: "14px 20px", cursor: "pointer", display: "flex", alignItems: "center" }}>
                  <span onClick={(e) => {e.stopPropagation(); setMenuToggle(false); navigate("/raiserequest")}}
                    style={{display: "flex", alignItems: "center", gap: "10px", paddingLeft: "5px", flexShrink: 0, color:
                    location.pathname === "/raiserequest" ? "#0d6efd" : "inherit",
                    }}
                  >
                    <i className="bx bx-message-square-add" style={{ fontSize: "20px" }} />
                  {!collapsed && <span>Request</span>}
                  </span>
                    <div onClick={(e) => {
                        e.stopPropagation();
                        setMenuToggle((prev) => !prev);
                      }}
                      style={{flexGrow: 1, display: "flex", justifyContent: "flex-end", alignItems: "center", paddingLeft: "30px", cursor: "pointer"}}>
                      <i className="bx bx-chevron-right" style={{fontSize: "20px", transition: "0.2s", transform: menuOpen ? "rotate(90deg)" : "rotate(0deg)"}}/>
                    </div>
                </div>
              }
            >
              <MenuItem component={<Link to="/project" />} icon={<i className="bx bx-briefcase" style={{ fontSize: "18px" }} />}
                style={{fontSize: "14px", padding: "8px 30px", ...isActive("/project")}}>
                Project
              </MenuItem>

              <MenuItem component={<Link to="/sample" />} icon={<i className="bx bx-bar-chart" style={{ fontSize: "18px" }} />}
                style={{fontSize: "14px", padding: "8px 30px", ...isActive("/sample")}}>
                Sample
              </MenuItem>
            </SubMenu>
          )}
         {["client"].includes(user_role) && (

  <SubMenu
  open={contactsMenuOpen}
  style={{ fontSize: "14px", padding: "0px" }}
  label={
    <div
      className={isContactsActive ? "request-active" : ""}
      style={{
        width: "100%",
        padding: "14px 20px",
        display: "flex",
        alignItems: "center",
        cursor: "pointer",
      }}
    >
      {/* LEFT: ICON + TEXT (NAVIGATE ONLY) */}
      <span
        onClick={(e) => {
          e.stopPropagation();
          navigate("/contact-filter");
          setContactsMenuOpen(true);
        }}
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          color: isContactsActive ? "#0d6efd" : "inherit",
          flexShrink: 0,
        }}
      >
        <i className="bx bx-book" style={{ fontSize: "20px" }} />
        {!collapsed && <span>My Contacts</span>}
      </span>

      {/* RIGHT: EMPTY SPACE + ARROW (TOGGLE) */}
      <div
        onClick={(e) => {
          e.stopPropagation();
          setContactsMenuOpen((prev) => !prev);
        }}
        style={{
          flexGrow: 1,
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          paddingLeft: "16px",
        }}
      >
        <i
          className="bx bx-chevron-right"
          style={{
            fontSize: "20px",
            transition: "0.2s",
            transform: contactsMenuOpen
              ? "rotate(90deg)"
              : "rotate(0deg)",
          }}
        />
      </div>
    </div>
  }
>

    {/* {["contactType", "location", "company", "industry", "technology", "continent"].map(
  (type) => {
    const values = getUniqueValues(type);
     const isOpen = accordionOpen[type]; 
    return (
      <div key={type} style={{ paddingLeft: "20px" }}>
        
        <div
          onClick={() =>
            setAccordionOpen((p) => ({ ...p, [type]: !p[type] }))
          }
          style={{
            cursor: "pointer",
            padding: "8px 10px",
            fontWeight: 500,
            display: "flex",
            justifyContent: "space-between",
            color: isOpen ? "rgb(13, 110, 253)" : "#212529",
          }}
        >
          <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
  {filterIcons[type]}
  {type === "contactType"
    ? "Contact Type"
    : type.charAt(0).toUpperCase() + type.slice(1)}
</span>
          <i
            className="bx bx-chevron-right"
            style={{
              transform: accordionOpen[type]
                ? "rotate(90deg)"
                : "rotate(0deg)",
              transition: "0.2s",
            }}
          />
        </div>

        
        {accordionOpen[type] && (
          <div style={{ paddingLeft: "15px" }}>
            {loadingContacts ? (
              <p style={{ fontSize: "12px" }}>Loading...</p>
            ) : values.length === 0 ? (
              <p style={{ fontSize: "12px" }}>No data</p>
            ) : (
              values.map((val) => (
                <label
                  key={val}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    fontSize: "13px",
                    padding: "4px 0",
                    cursor: "pointer",
                  }}
                >
                  <input
                    type="checkbox"
                    checked={
                      contactFilters[type]?.includes(val) || false
                    }
                    onChange={() => toggleFilterValue(type, val)}
                  />
                  {val}
                </label>
              ))
            )}
          </div>
        )}
        
      </div>
    );
  }
)} */}
{["contactType", "location", "company", "industry", "technology", "continent"].map(
  (type) => {
    const values = getUniqueValues(type);
    const isOpen = accordionOpen[type];

    return (
      <div key={type} style={{ paddingLeft: "20px" }}>
        {/* Accordion Header */}
        <div
          onClick={() =>
            setAccordionOpen((p) => ({ ...p, [type]: !p[type] }))
          }
          style={{
            cursor: "pointer",
            padding: "8px 10px",
            fontWeight: 500,
            display: "flex",
            justifyContent: "space-between",
            color: isOpen ? "rgb(13, 110, 253)" : "#212529",
          }}
        >
          <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            {filterIcons[type]}
            {type === "contactType"
              ? "Contact Type"
              : type.charAt(0).toUpperCase() + type.slice(1)}
          </span>
          <i
            className="bx bx-chevron-right"
            style={{
              transform: accordionOpen[type] ? "rotate(90deg)" : "rotate(0deg)",
              transition: "0.2s",
            }}
          />
        </div>

        {/* Accordion Body */}
        {accordionOpen[type] && (
          <div
            style={{
              paddingLeft: "15px",
              maxHeight: "200px", // <-- set height here
              overflowY: "auto",  // <-- scroll when content exceeds height
            }}
          >
            {loadingContacts ? (
              <p style={{ fontSize: "12px" }}>Loading...</p>
            ) : values.length === 0 ? (
              <p style={{ fontSize: "12px" }}>No data</p>
            ) : (
              values.map((val) => (
                <label
                  key={val}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    fontSize: "13px",
                    padding: "4px 0",
                    cursor: "pointer",
                    whiteSpace:"nowrap"
                  }}
                >
                  <input
                    type="checkbox"
                    checked={contactFilters[type]?.includes(val) || false}
                    onChange={() => toggleFilterValue(type, val)}
                  />
                  {val}
                </label>
              ))
            )}
          </div>
        )}
      </div>
    );
  }
)}


  </SubMenu>
)}



        </Menu>
      </Sidebar>

      <Modal show={modalShow} onHide={() => setModalShow(false)} className="logout-modal"
        centered>
        <Modal.Body className="text-center">
          <img src={logOutImg} alt="Logout" className="logout_img mb-3" />
          <h6>Are you sure you want to log out?</h6>
        </Modal.Body>
        <Modal.Footer className="justify-content-center">
          <ClearBtn btnName="No, Stay" onClickEffect={() => setModalShow(false)} />
          <SearchBtn btnName="Yes, Logout" onClickEffect={logOutPage} />
        </Modal.Footer>
      </Modal>

    </>
  );
};

export default AppSidebar;